export const RICALCOLO = 'ricalcolo'
export const CHANGE_VALORE = 'change_valore'
export const CHANGE_PAGINA = 'change_pagina'
export const RESET = 'reset'